import client from "../utils/client";

export const ACTIONS = {
  SET_SHIRTS: "SET_SHIRTS",
  SET_BOOTSTRAP_DATA: "SET_BOOTSTRAP_DATA",
  SET_USER_INTERACTIONS: "SET_USER_INTERACTIONS",
  SET_PURCHASE_DETAILS: "SET_PURCHASE_DETAILS",
  SET_USER_DATA: "SET_USER_DATA",
  SET_SHOW_LOGIN: "SET_SHOW_LOGIN",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_LOADING: "SET_LOADING",
  SET_TOKEN_READY: "SET_TOKEN_READY",
  SET_POST_LOGIN_REDIRECT: "SET_POST_LOGIN_REDIRECT"
};

export const getBootstrapData = () => async dispatch => {
  try {
    const response = await client.getShirtGalleryBootstrapData();

    dispatch({
      data: response.data,
      type: ACTIONS.SET_BOOTSTRAP_DATA
    });
  } catch (err) {
    throw err;
  }
};

export const getShirts = ({
  design = [],
  pattern = [],
  fabric = [],
  gender,
  sort = "gallery_added_date",
  sortType,
  sotw_only,
  page = 1,
  per_page = 21,
  cuff = [],
  collar = [],
  weave = [],
  compositions = [],
  contrast_family = [],
  family = [],
  wishlistView } = {}) => async dispatch => {
    if (page === 1) {
      dispatch({
        data: true,
        type: ACTIONS.SET_LOADING
      })
    }

    try {
      const filters = {
        fabricIds: fabric,
        familyIds: family,
        contrastFamilyIds: contrast_family,
        patterns: pattern,
        types: [],
        weaves: weave,
        compositionIds: compositions,
        designs: design,
        cuffStyles: cuff,
        collarStyles: collar,
        myShirtOnly: wishlistView,
        sotwOnly: sotw_only,
      }

      const data = await client.getShirtGalleryShirts(filters, sort, sortType, page, per_page);

      dispatch({
        data: data,
        type: ACTIONS.SET_SHIRTS
      });

      dispatch({
        data: false,
        type: ACTIONS.SET_LOADING
      });
    } catch (err) {
      throw err;
    }
  };

export const changePage = (value) => async dispatch => {
  try {
    dispatch({
      data: value,
      type: ACTIONS.SET_CURRENT_PAGE
    });
  } catch (err) {
    throw err;
  }
};

export const showLoginModal = (showModal, redirect = null) => async dispatch => {
  try {
    dispatch({
      data: redirect,
      type: ACTIONS.SET_POST_LOGIN_REDIRECT
    });

    dispatch({
      data: showModal,
      type: ACTIONS.SET_SHOW_LOGIN
    });
  } catch (err) {
    throw err;
  }
};

export const reloadUserInteractions = () => async dispatch => {
  try {
    const response = await client.getUserInteractions();
    dispatch({
      data: response.data,
      type: ACTIONS.SET_USER_INTERACTIONS
    });
  } catch (err) {

  }

};

export const addToWishlist = (shirtOrderId) => async dispatch => {
  try {
    const response = await client.addToWishList(shirtOrderId);
    dispatch({
      data: response.data,
      type: ACTIONS.SET_USER_INTERACTIONS
    });
  } catch (err) {
    throw err;
  }
};

export const addToLikeList = (shirtOrderId) => async dispatch => {
  try {
    const response = await client.addLike(shirtOrderId);
    dispatch({
      data: response.data,
      type: ACTIONS.SET_USER_INTERACTIONS
    });
  } catch (err) {
    throw err;
  }
};

export const removeFromWishlist = (shirtOrderId) => async dispatch => {
  try {
    const response = await client.removeFromWishList(shirtOrderId);
    dispatch({
      data: response.data,
      type: ACTIONS.SET_USER_INTERACTIONS
    });
  } catch (err) {
    throw err;
  }
};

export const removeFromLikeList = (shirtOrderId) => async dispatch => {
  try {
    const response = await client.removeLike(shirtOrderId);
    dispatch({
      data: response.data,
      type: ACTIONS.SET_USER_INTERACTIONS
    });
  } catch (err) {
    throw err;
  }
};

export const login = (type, email, pass) => async (dispatch, getState) => {
  
  try {
    const data = await client.getUserAccessToken(email, pass, type, '');

    if (data.status) {

      // Check if we should redirect after login
      const { postLoginRedirect } = getState().Gallery
      if(postLoginRedirect !== null) {
        window.location.href = postLoginRedirect;
      }

      dispatch(showLoginModal(false))
      dispatch(reloadUserInteractions());
      dispatch({
        data: true,
        type: ACTIONS.SET_TOKEN_READY
      });
    }

    dispatch({
      data: data,
      type: ACTIONS.SET_USER_DATA
    });

  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const loginDirectly = () => async dispatch => {
  try {
    dispatch({
      data: window.userAuthInfo,
      type: ACTIONS.SET_USER_DATA
    });

    dispatch({
      data: true,
      type: ACTIONS.SET_TOKEN_READY
    });
    dispatch(reloadUserInteractions());

  } catch (err) {
    throw err;
  }
};
